import { mountDashboardReportNavigation } from '../../frontend/components/common/dashboard/utils/dashboard-report-navigation';

const cleanups = new WeakMap();

export async function initializeReportProductNavigation(doc = document, load = url => fetch(url, {
  credentials: 'same-origin',
  headers: { Accept: 'application/json' },
})) {
  const marker = doc.querySelector('[data-report-navigation-url]');
  const dashboardFrame = doc.defaultView.self !== doc.defaultView.top
    && new URLSearchParams(doc.defaultView.location.search).get('embedded_dashboard') === '1';
  const url = marker?.dataset.reportNavigationUrl;

  // The Dashboard supplies its own navigation in the order of its filtered table.
  if (!url || marker.dataset.navigationStarted === url || dashboardFrame) {
    return;
  }

  cleanups.get(marker)?.();
  marker.dataset.navigationStarted = url;

  try {
    const response = await load(url);

    if (!response.ok) {
      return;
    }

    const { nextReport, previousProduct, nextProduct } = await response.json();
    const frameReport = doc.defaultView.self !== doc.defaultView.top ? nextReport : null;

    if ((!frameReport && !previousProduct && !nextProduct) || marker.dataset.navigationStarted !== url) {
      return;
    }

    const cleanup = mountDashboardReportNavigation(doc, { nextReport: frameReport, previousProduct, nextProduct }, target => {
      const view = doc.defaultView;

      // Keep the Reports tab's URL and Back action in sync with the report displayed in its frame.
      if (target.url.startsWith('/analysis-reports/')) {
        const frameId = view.frameElement?.id;

        if (frameId === 'reportIframe' && view.parent.analyticsGridView?.showReportInCardBody) {
          view.parent.analyticsGridView.showReportInCardBody(target.url, target.productName, target.id, target.uuid);
          return;
        }

        if (frameId === 'optixReportIframe' && view.parent.showReportInCurrentTab) {
          view.parent.showReportInCurrentTab(target.url, target.productName, target.id, target.uuid);
          return;
        }
      }

      doc.defaultView.location.assign(target.url);
    });
    cleanups.set(marker, cleanup);
  } catch {
    // Navigation is optional: opening an existing report must still work if this request fails.
  }
}

function start() {
  initializeReportProductNavigation();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', start, { once: true });
} else {
  start();
}
